import React, {useRef, useState, useEffect} from 'react'
import './contact.css';
import emailjs from '@emailjs/browser';

import ColorStack from '../../assets/colorStack.png'
import Forage from '../../assets/forage.png'
import JPMorgan from '../../assets/jpm.png'
import HPE from '../../assets/hpe.jpg'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';
import { faHandshake } from '@fortawesome/free-solid-svg-icons';

const Contact = () => {
    const form = useRef();
    const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });
    
    // Initialize EmailJS with public key
    useEffect(() => {
        emailjs.init('1sbX5g73u7qNp0Eae');
    }, []);
    
    const sendEmail = (e) => {
        e.preventDefault();
        const formData = new FormData(form.current);
        const name = formData.get('from_name');
        const email = formData.get('from_email');
        const message = formData.get('message');
        
        if (!name || !email || !message) {
            setSubmitStatus({ type: 'error', message: 'Please fill in all fields' });
            return;
        }
        
        if (!email.includes('@')) {
            setSubmitStatus({ type: 'error', message: 'Please enter a valid email address' });
            return;
        }
        
        setSubmitStatus({ type: 'loading', message: 'Sending...' });
        
        emailjs.sendForm('service_v7585n8', 'template_0rr7ksp', form.current)
            .then(
                () => {
                    setSubmitStatus({ type: 'success', message: 'Email sent successfully!' });
                    e.target.reset();
                    setTimeout(() => setSubmitStatus({ type: '', message: '' }), 3000);
                },
                (error) => {
                    console.error('EmailJS Error:', error);
                    setSubmitStatus({ type: 'error', message: `Failed to send email: ${error.text || 'Please check your EmailJS configuration'}` });
                    setTimeout(() => setSubmitStatus({ type: '', message: '' }), 5000);
                }
            );
    };
    
    return (
        <section id="contactPage">
            <div id="clients">
                <h1 className="contactPageTitle">My Affiliations</h1>
                <p className="clientDesc">I have had the opportunity to join organizations and obtain certificates. Some of the organizations and certificates I've completed include:</p>
            <div className="clientImgs">
                <img src={ColorStack} alt="ColorStack" className="clientImg" />
                <img src={Forage} alt="Forage" className="clientImg" />
                <img src={JPMorgan} alt="JPMorgan Chase" className="clientImg" />
                <img src={HPE} alt="Hewlett Packard Enterprise" className="clientImg" />
            </div>
            </div>
            <div id="contact">
                <h1 className="contactPageTitle">Contact Me</h1>
                <span className="contactDesc">Please fill out the form below to contact me.</span>
                <form className="contactForm" ref={form} onSubmit={sendEmail}>
                    <input type="text" className="name" placeholder='Your Name' name='from_name' required/>
                    <input type="email" className="email" placeholder='Your Email' name='from_email' required/>
                    <textarea className= 'msg' name="message" rows='5' placeholder='Your Message' required></textarea>
                    {submitStatus.message && (
                        <div className={`submitStatus ${submitStatus.type}`}>
                            {submitStatus.message}
                        </div>
                    )}
                    <button type='submit' value='Send' className="submitBtn" disabled={submitStatus.type === 'loading'}>
                        {submitStatus.type === 'loading' ? 'Sending...' : 'Submit'}
                    </button>
                    <div className="links">
                        <a href="https://www.linkedin.com/in/mohsinshah04/" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faLinkedin} className = 'link'/>                        </a>
                        <a href="https://app.joinhandshake.com/stu/users/38469640" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faHandshake} className = 'link'/>                     
                        </a>
                        <a href="https://github.com/mohsinshah04" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faGithub} className = 'link'/>
                        </a>
                    </div>
                </form>
            </div>
        </section>
    );
};

export default Contact;